import { Box, CardMedia, Skeleton } from "@mui/material";
import { useCallback, useState } from "react";

const ImageWithLoader = ({
  variant = "rounded",
  style,
  component,
  sx,
  loading,
  disableLoader,
  ...props
}) => {
  const [imgLoading, setImgLoading] = useState(true);
  const onImageLoad = useCallback(() => setImgLoading(false), []);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {imgLoading && (
        <Skeleton
          variant={variant}
          sx={{ height: { md: "19vh", xs: "8vh" } }}
        />
      )}
      {
        <img
          {...props}
          loading={loading}
          style={{
            ...(style || {}),
            ...(sx || {}),
            visibility: imgLoading ? "hidden" : "visible",
          }}
          onLoad={onImageLoad}
          alt=""
        />
      }
    </Box>
  );
};

export default ImageWithLoader;
